// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"55b2b18c","275":"07b5608e","587":"55b2b18c"}[chunkId] + ".chunk.css";
};